import { canadaFinalCtaData, canadaStripeUrl, canadaWhatsappUrl } from "../../data/canadaTaxData";
import { ArrowRight, CheckCircle2, Zap, MessageCircle } from "lucide-react";

export const CanadaFinalCTASection = () => {
  const deadline = new Date("2026-04-30");
  const daysLeft = Math.ceil((deadline - new Date()) / (1000 * 60 * 60 * 24));

  return (
    <section id="cta" className="relative py-28 px-6 overflow-hidden bg-[#0B1829]">
      {/* Red glow */}
      <div
        className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] pointer-events-none"
        style={{ background: "radial-gradient(ellipse at bottom, rgba(200,40,58,0.15) 0%, transparent 70%)" }}
      />

      <div className="relative max-w-2xl mx-auto text-center">
        {/* Urgency tag */}
        <div className="inline-flex items-center gap-2 bg-[#C8283A]/15 border border-[#C8283A]/30 text-[#E63449] text-xs font-bold px-4 py-2 rounded-full mb-6" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
          <Zap size={12} />
          Only {daysLeft} days until CRA deadline
        </div>

        <h2 className="text-white font-black leading-tight mb-5" style={{ fontFamily: "'Inter', Arial, sans-serif", fontSize: "clamp(2rem, 1.6rem + 2.5vw, 3.5rem)", letterSpacing: "-0.04em" }}>
          {canadaFinalCtaData.headline1}
          <br />
          <span className="text-[#C8283A] italic">{canadaFinalCtaData.headline2}</span>
        </h2>

        <p className="text-[#8BA3BE] text-base leading-relaxed mb-10 max-w-lg mx-auto" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
          {canadaFinalCtaData.sub}
        </p>

        <div className="flex flex-col items-center gap-5">
          {/* Primary CTA */}
          <a
            href={canadaStripeUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="canada-final-cta"
            className="group inline-flex items-center gap-3 bg-[#C8283A] text-white font-black text-base sm:text-lg px-10 py-5 rounded-xl transition-all duration-300 hover:bg-[#E63449] hover:scale-[1.02] active:scale-[0.98] shadow-xl shadow-[#C8283A]/30 uppercase tracking-tight"
            style={{ fontFamily: "'Inter', Arial, sans-serif" }}
          >
            <span>File My Return — $40 CAD</span>
            <ArrowRight size={18} className="transition-transform group-hover:translate-x-1 flex-shrink-0" />
          </a>

          {/* WhatsApp secondary */}
          <a
            href={canadaWhatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="canada-whatsapp-cta"
            className="inline-flex items-center gap-2 text-[#8BA3BE] hover:text-[#D4A843] text-sm font-semibold transition-colors duration-200"
            style={{ fontFamily: "'Inter', Arial, sans-serif" }}
          >
            <MessageCircle size={15} />
            Or WhatsApp us directly
          </a>

          {/* Trust items */}
          <div className="flex flex-wrap justify-center items-center gap-5 mt-2">
            {canadaFinalCtaData.trustItems.map((item, i) => (
              <span key={i} className="flex items-center gap-2 text-[#8BA3BE] text-xs" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                <CheckCircle2 size={13} className="text-[#D4A843] flex-shrink-0" />
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
